import React from 'react';
import styled from 'styled-components';

const Alert = ({ content }) => {
    return (
        <AlertWrap>
            <h2>Error</h2>
            {content}
        </AlertWrap>
    );
}

const AlertWrap = styled.section`
    background-color: #FFCDD2; 
    color: #D32F2F; 
    border-radius: 4px;
    padding: 5px;

    h2 {
        color: #D32F2F; /* Dark red title color */
        margin-bottom: 0.5rem;
        font-size: 2rem;
    }
`;


export default Alert;
